import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

import Button from 'components/Button';
import Link from 'components/Link';
import ChatFeedbackQuestion from './ChatFeedbackQuestion';
import { getChatQuestionnaire, getChatFeedbackIsFilled, getChatFeedbackSubmission } from 'selectors';
import * as actions from 'actions';
import './style.scss';
import { QuestionnaireShape } from 'entities';

export const ChatFeedback = props => {

  function handleSubmit(event) {
    event.preventDefault();

    if(props.canSubmit) {
      props.onSubmit(props.questionnaire);
    }
  }

  function handleAnswer(question, answerId, answerValue) {
    if(!props.isSubmitting) {
      props.onQuestionAnswer(props.questionnaire, question, answerId, answerValue);
    }
  }

  function handleCloseClick(event) {
    event.preventDefault();
    props.onClose(props.questionnaire);
  }

  return (
    <div className="ChatFeedback">
      <div className="head">
        <Link to="_" onClick={handleCloseClick} iconName="search-close">{__('members.chat.feedback.back')}</Link>
        <h4>{__('members.chat.feedback.title')}</h4>
      </div>

      <div className="wrapper-full">
        <div className="questions-list">
          <form>
            {(() => {
              if(props.questionnaire) {
                return props.questionnaire.questions.map(question =>
                  <ChatFeedbackQuestion key={question.id} onAnswer={handleAnswer} question={question} />
                );
              }
            })()}

            <Button isDisabled={!props.canSubmit || props.isSubmitting} isYellow onClick={handleSubmit}>
              {props.isSubmitting ? __('members.chat.feedback.submitting') : __('members.chat.feedback.submit')}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

ChatFeedback.propTypes = {
  questionnaire: QuestionnaireShape,
  onQuestionAnswer: PropTypes.func,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
  canSubmit: PropTypes.bool,
  isSubmitting: PropTypes.bool
};

const mapStateToProps = (state) => {
  return {
    questionnaire: getChatQuestionnaire(state, 'eos'),
    canSubmit: getChatFeedbackIsFilled(state),
    isSubmitting: getChatFeedbackSubmission(state).isSubmitting
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onQuestionAnswer: (questionnaire, question, answer, value) => {
      dispatch(actions.chatQuestionUpdate(questionnaire.id, question.id, { answer, value }));
    },
    onSubmit: (questionnaire) => {
      dispatch(actions.chatQuestionnaireSubmit(questionnaire));
    },
    onClose: (questionnaire) => {
      dispatch(actions.chatQuestionnaireUpdate(questionnaire.id, {declined: true}));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatFeedback);



/** WEBPACK FOOTER **
 ** ./src/members/Main/ChatWindow/ChatFeedback/index.js
 **/